export default __webpack_public_path__ + "static/media/2-Ano-01-Aqui-E-Seguro.94d29876.png";